import { Cartesian3 } from "../../geometry";
export var RefinementStrategy;
(function (RefinementStrategy) {
    RefinementStrategy[RefinementStrategy["ADDITIVE"] = 0] = "ADDITIVE";
    RefinementStrategy[RefinementStrategy["REPLACEMENT"] = 1] = "REPLACEMENT";
})(RefinementStrategy || (RefinementStrategy = {}));
export function ScreenSpaceError(node, position, viewportHeight, fov) {
    const center = node.boundingBox?.center ?? Cartesian3.Zero();
    const d = Cartesian3.Distance(center, position);
    return (node.geometricError * viewportHeight) / (d * Math.tan(fov / 2));
}
export function ScreenSpaceError0(geometricError, distance, viewportHeight, tanfov2) {
    return (geometricError * viewportHeight) / (distance * tanfov2);
}
//# sourceMappingURL=tile3d.interfaces.js.map